import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
} from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

const propsSchema: PropsSchemaList = [
  {
    key: 'colorTheme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'items',
    label: 'Description Blocks',
    type: types.ARRAY,
    options: {
      maxLength: 4
    },
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
        options: {
          maxLength: 70
        }
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT,
        options: {
          maxLength: 300
        }
      },
    ]
  }
];

const defaultProps = {
  colorTheme: COMPONENT_COLOR_THEMES[0],
  items: [{
    title: 'One car to replace sedan, sports car and SUV',
    description: 'The smooth, plush ride of a luxury sedan, sporty handling and power of a sports car, and the spaciousness and utility that comes with an SUV, the FF 91 Futurist combines the best of three worlds.',
  }, {
    title: 'Inside out design language',
    description: 'Contrary to the busy designs seen in the industry today, the FF 91 Futurist’s design starts from the interior. It is clean and simple… a mono-thematic theory that makes a precise statement of elegance and beauty.',
  }, {
    title: 'UFO mode made of 10,000 LEDs',
    description: 'A lighting system that is unmatched, the FF 91 Futurist will display a unique, 3D crystal-like array that stands apart from anything else on the road; each individual LED is programmable, enabling customized lighting animations that communicates with the world around it.',
  }, {
    title: 'Superior Safety',
    description: 'Safety is ingrained in every aspect of the FF 91 Futurist. Engineered from the ground up with the utmost safety in mind, starting with our patented VPA platform that provides a high-strength architecture.',
  }]
};

export default {
  title: 'Description Blocks',
  id: 'DescriptionBlocks',
  propsSchema,
  defaultProps
};
